<template>
  <v-data-iterator :items="teamCriteriaData?.data" item-value="id">
    <template v-slot:default="{ items, isExpanded, toggleExpand }">
      <v-row>
        <v-col v-for="item in items" :key="item.raw.criteria?.id">
          <v-card>
            <v-card-title class="d-flex align-center">
              <h4>{{ item.raw.criteria?.name }}</h4>
            </v-card-title>

            <v-card-text>
              <div v-html="item.raw.criteria?.description"></div>

              <div v-if="item.raw.criteria?.thubmnail" class="d-flex justify-center align-center">
                <v-img :src="item.raw.criteria?.thubmnail.url">
                  <template #sources>
                    <source :srcset="item.raw.criteria.thubmnail?.webp_url" />
                  </template>
                </v-img>
              </div>
              <vue3-video-player
                v-if="item.raw.criteria?.video"
                :src="item.raw.criteria.video.url"
                preload="false"></vue3-video-player>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-data-iterator>
</template>
<script setup lang="ts">
import { useCriteriaStore } from '@/stores';
import { computed } from 'vue';

interface Props {
  teamId: string;
  yearId: string;
}
const props = defineProps<Props>();

const teamId = computed(() => props.teamId ?? '');
const yearId = computed(() => props.yearId ?? '');
const criteriaStore = useCriteriaStore();
const { data: teamCriteriaData } = criteriaStore.getTeamsCriteriaQuery(yearId, teamId);
</script>
